<template>
  <div class="game-page">
    <div v-if="preparingEntry && !transferPopupOpen && !url" class="game-status-hint">
      正在读取余额...
    </div>
    <div v-if="openingGame" class="game-status-hint">
      正在进入游戏...
    </div>
    <div v-if="url" class="game-frame-wrap">
      <iframe :src="url" style="height: 100%; width: 100%" ref="iframe" scrolling="auto" frameborder="0" id="iframe" @load="handleIframeLoad"></iframe>
    </div>
    <van-action-sheet v-model="transferPopupOpen" title="进入游戏前转账">
      <div class="transfer-sheet">
        <div class="transfer-card">
          <div class="transfer-row">
            <span>平台余额</span>
            <strong>{{ $store.state.userInfo.balance || 0 }}</strong>
          </div>
          <div class="transfer-row">
            <span>目标场馆余额</span>
            <strong>{{ targetGameInfo.balance || 0 }}</strong>
          </div>
          <div class="transfer-row">
            <span>场馆总余额</span>
            <strong>{{ $store.state.userInfo.gameblance || 0 }}</strong>
          </div>
          <div class="transfer-row">
            <span>目标场馆</span>
            <strong>{{ displayTargetGameName }}</strong>
          </div>
        </div>
        <div class="transfer-input">
          <div class="transfer-label-row">
            <div class="transfer-label">转入金额</div>
            <div class="transfer-recycle" :class="{ 'is-disabled': !canRecycleBalance || recycleSubmitting }" @click="recycleBalance">
              {{ recycleButtonText }}
            </div>
          </div>
          <input v-model.trim="transferAmount" type="number" inputmode="decimal" placeholder="请输入转账金额，不填则直接进入" />
        </div>
        <div class="transfer-actions">
          <div class="transfer-action transfer-action--ghost" @click="enterGameDirectly">直接进入</div>
          <div class="transfer-action" @click="transferAndEnterGame">确认转账</div>
        </div>
      </div>
    </van-action-sheet>
    <div
      class="floating-menu"
      :class="{
        'is-open': menuOpen,
        'is-dragging': isDragging,
        'is-edge-right': snappedEdge === 'right',
        'is-edge-left': snappedEdge === 'left',
      }"
      :style="floatingStyle"
    >
      <transition name="float-actions">
        <div
          v-if="menuOpen"
          class="floating-actions"
          :class="{
            'actions-left': snappedEdge === 'right',
            'actions-right': snappedEdge === 'left',
          }"
        >
          <div class="action-item" @click.stop="exitPage">退出</div>
          <div class="action-item" @click.stop="goHome">返回首页</div>
        </div>
      </transition>
      <div
        class="floating-trigger"
        @click.stop="toggleMenu"
        @mousedown="handlePressStart"
        @touchstart="handlePressStart"
      >
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'gamePage',
  data() {
    return {
      url: null,
      menuOpen: false,
      isDragging: false,
      dragMoved: false,
      snappedEdge: 'right',
      floatingButton: {
        x: 0,
        y: 0,
      },
      dragOffset: {
        x: 0,
        y: 0,
      },
      pressTimer: null,
      pressPoint: {
        x: 0,
        y: 0,
      },
      buttonSize: 56,
      edgeHideOffset: 18,
      transferPopupOpen: false,
      transferAmount: '',
      pendingGame: {
        name: '',
        type: 0,
        code: '',
      },
      targetGameInfo: {
        platname: '',
        name: '',
        balance: 0,
      },
      transferSubmitting: false,
      recycleSubmitting: false,
      balancePollingTimer: null,
      balancePollingBusy: false,
      preparingEntry: false,
      openingGame: false,
      openingGameTimer: null,
      walletSyncTriggered: false,
    };
  },
  created() {
    let that = this;
    var query = that.$route.query;
    // 打开代理
    console.log(query)
    if (query.dailiD == 1) {
      that.getAgentLoginUrl();
      return;
    }
    // 打开客服
    if (query.dailiD == 2) {
      that.getservicerurl();
      return;
    }
    if (query.app == 1) {
     that.url = that.$store.state.appInfo.ios_download_url;
      return;
    }
    if (query.name) {
      that.prepareGameEntry(query.name, query.type, query.code);
    }
  },
  methods: {
    syncUserTransferstatus(transferstatus) {
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
      userInfo.transferstatus = transferstatus;
      localStorage.setItem('userInfo', JSON.stringify(userInfo));
      this.$store.commit('changUserInfo');
    },
    syncUserBalance(balance) {
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
      userInfo.balance = balance;
      localStorage.setItem('userInfo', JSON.stringify(userInfo));
      this.$store.commit('changUserInfo');
    },
    syncUserWalletInfo(data = {}) {
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
      if (typeof data.balance !== 'undefined') {
        userInfo.balance = data.balance;
      }
      if (typeof data.gameblance !== 'undefined') {
        userInfo.gameblance = data.gameblance;
      }
      if (typeof data.transferstatus !== 'undefined') {
        userInfo.transferstatus = data.transferstatus;
      }
      localStorage.setItem('userInfo', JSON.stringify(userInfo));
      this.$store.commit('changUserInfo');
    },
    ensureTransferWalletMode() {
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
      const transferstatus = Number(userInfo.transferstatus != null ? userInfo.transferstatus : this.$store.state.userInfo.transferstatus || 0);
      if (transferstatus === 0) {
        return Promise.resolve();
      }
      return this.$apiFun.post('/api/uptransferstatus', { transferstatus: 0 }).then(res => {
        if (res.code !== 200) {
          return Promise.reject(new Error(res.message || '切换转账模式失败'));
        }
        this.syncUserTransferstatus(0);
        return res;
      });
    },
    prepareGameEntry(name, type, code) {
      if (!this.$store.state.token) {
        this.$parent.showTost(0, '请先登录');
        this.$router.push('/login');
        return;
      }
      this.pendingGame = {
        name,
        type: type || 0,
        code: code || '',
      };
      this.transferAmount = '';
      this.targetGameInfo = {
        platname: String(name || '').toLowerCase(),
        name: '',
        balance: 0,
      };
      this.transferPopupOpen = true;
      this.preparingEntry = true;
      this.ensureTransferWalletMode()
        .then(() => this.refreshTransferBalances(name, true))
        .catch(error => {
          this.$parent.showTost(0, (error && error.message) || '加载转账信息失败');
        })
        .finally(() => {
          this.preparingEntry = false;
        });
    },
    refreshUserMoney() {
      return this.$apiFun
        .post('/api/refreshusermoney', {})
        .then(res => {
          if (res.code === 200) {
            this.syncUserWalletInfo(res.data || {});
          }
          return res;
        })
        .catch(() => null);
    },
    refreshTargetGameInfo(name) {
      return this.$apiFun.post('/api/balancelist', {}).then(res => {
        if (res.code !== 200) {
          return Promise.reject(new Error(res.message || '读取场馆余额失败'));
        }
        const targetGameInfo = (res.data || []).find(item => String(item.platname).toLowerCase() === String(name).toLowerCase());
        this.targetGameInfo = targetGameInfo || {
          platname: name,
          name: '',
          balance: 0,
        };
        return this.targetGameInfo;
      });
    },
    refreshTransferBalances(name, silent = false) {
      const targetName = name || this.pendingGame.name;
      if (!targetName || this.balancePollingBusy) {
        return Promise.resolve();
      }
      this.balancePollingBusy = true;
      return Promise.all([
        this.refreshUserMoney(),
        this.refreshTargetGameInfo(targetName),
      ])
        .catch(error => {
          if (!silent) {
            return Promise.reject(error);
          }
          return null;
        })
        .finally(() => {
          this.balancePollingBusy = false;
        });
    },
    startBalancePolling() {
      this.stopBalancePolling();
      this.balancePollingTimer = setInterval(() => {
        if (!this.transferPopupOpen || this.transferSubmitting || this.recycleSubmitting) {
          return;
        }
        this.refreshTransferBalances(this.pendingGame.name, true);
      }, 5000);
    },
    stopBalancePolling() {
      if (this.balancePollingTimer) {
        clearInterval(this.balancePollingTimer);
        this.balancePollingTimer = null;
      }
    },
    recycleBalance() {
      if (this.recycleSubmitting || !this.canRecycleBalance) {
        return;
      }
      this.recycleSubmitting = true;
      this.$parent.showLoading();
      this.$apiFun
        .post('/api/transall', {})
        .then(res => {
          if (res.code !== 200) {
            this.$parent.showTost(0, res.message);
            return;
          }
          this.$parent.showTost(1, res.message || '回收成功');
          return this.refreshTransferBalances(this.pendingGame.name, true);
        })
        .catch(() => {
          this.$parent.showTost(0, '回收失败，请稍后重试');
        })
        .finally(() => {
          this.recycleSubmitting = false;
          this.$parent.hideLoading();
        });
    },
    transferAndEnterGame() {
      if (this.transferSubmitting) {
        return;
      }
      const amount = Number(this.transferAmount);
      let shouldHideLoading = true;
      if (!this.transferAmount) {
        this.enterGameDirectly();
        return;
      }
      if (!amount || amount <= 0) {
        this.$parent.showTost(0, '请输入正确的转账金额');
        return;
      }
      this.transferSubmitting = true;
      this.$parent.showLoading();
      this.$apiFun
        .post('/api/transfer', {
          amount,
          sourcetype: 'userbalance',
          targettype: this.targetGameInfo.platname || this.pendingGame.name,
        })
        .then(res => {
          if (res.code !== 200) {
            this.$parent.showTost(0, res.message);
            return;
          }
          if (res.data && typeof res.data.balance !== 'undefined') {
            this.syncUserBalance(res.data.balance);
          }
          this.$parent.showTost(1, '转账成功');
          shouldHideLoading = false;
          this.$parent.hideLoading();
          this.enterGameDirectly();
          this.refreshTransferBalances(this.pendingGame.name, true).catch(() => null);
        })
        .catch(() => {
          this.$parent.showTost(0, '转账失败，请稍后重试');
        })
        .finally(() => {
          this.transferSubmitting = false;
          if (shouldHideLoading) {
            this.$parent.hideLoading();
          }
        });
    },
    enterGameDirectly() {
      this.transferPopupOpen = false;
      this.goGamePage(this.pendingGame.name, this.pendingGame.type, this.pendingGame.code);
    },
    getEventPoint(event) {
      const point = event.touches && event.touches.length ? event.touches[0] : event;
      return {
        x: point.clientX,
        y: point.clientY,
      };
    },
    initFloatingButton() {
      if (typeof window === 'undefined') return;
      this.floatingButton.x = -this.edgeHideOffset;
      this.floatingButton.y = 88;
      this.snappedEdge = 'left';
    },
    clampFloatingPosition(x, y) {
      const width = window.innerWidth || 375;
      const height = window.innerHeight || 667;
      const minX = -this.edgeHideOffset;
      const maxX = width - this.buttonSize + this.edgeHideOffset;
      const minY = 20;
      const maxY = height - this.buttonSize - 20;
      return {
        x: Math.min(Math.max(x, minX), maxX),
        y: Math.min(Math.max(y, minY), maxY),
      };
    },
    bindPressListeners() {
      window.addEventListener('mousemove', this.handlePressMove);
      window.addEventListener('mouseup', this.handlePressEnd);
      window.addEventListener('touchmove', this.handlePressMove, { passive: false });
      window.addEventListener('touchend', this.handlePressEnd);
    },
    unbindPressListeners() {
      window.removeEventListener('mousemove', this.handlePressMove);
      window.removeEventListener('mouseup', this.handlePressEnd);
      window.removeEventListener('touchmove', this.handlePressMove);
      window.removeEventListener('touchend', this.handlePressEnd);
    },
    clearPressTimer() {
      if (this.pressTimer) {
        clearTimeout(this.pressTimer);
        this.pressTimer = null;
      }
    },
    handlePressStart(event) {
      const point = this.getEventPoint(event);
      this.pressPoint = {
        x: point.x,
        y: point.y,
      };
      this.dragMoved = false;
      this.bindPressListeners();
      this.clearPressTimer();
      this.pressTimer = setTimeout(() => {
        this.startDrag(point);
      }, 280);
    },
    startDrag(point) {
      const currentLeft = this.snappedEdge === 'left' ? -this.edgeHideOffset : this.floatingButton.x;
      const currentTop = this.floatingButton.y;
      this.isDragging = true;
      this.dragMoved = false;
      this.menuOpen = false;
      this.dragOffset = {
        x: point.x - currentLeft,
        y: point.y - currentTop,
      };
    },
    handlePressMove(event) {
      const point = this.getEventPoint(event);
      if (!this.isDragging) {
        if (Math.abs(point.x - this.pressPoint.x) > 8 || Math.abs(point.y - this.pressPoint.y) > 8) {
          this.clearPressTimer();
        }
        return;
      }
      if (event.cancelable) {
        event.preventDefault();
      }
      const next = this.clampFloatingPosition(point.x - this.dragOffset.x, point.y - this.dragOffset.y);
      this.floatingButton.x = next.x;
      this.floatingButton.y = next.y;
      this.dragMoved = true;
    },
    handlePressEnd() {
      this.clearPressTimer();
      if (!this.isDragging) {
        this.unbindPressListeners();
        return;
      }
      this.stopDrag();
    },
    stopDrag() {
      this.isDragging = false;
      const width = window.innerWidth || 375;
      const centerX = this.floatingButton.x + this.buttonSize / 2;
      if (centerX > width / 2) {
        this.snappedEdge = 'right';
        this.floatingButton.x = width - this.buttonSize + this.edgeHideOffset;
      } else {
        this.snappedEdge = 'left';
        this.floatingButton.x = -this.edgeHideOffset;
      }
      this.unbindPressListeners();
    },
    toggleMenu() {
      if (this.dragMoved) {
        this.dragMoved = false;
        return;
      }
      this.menuOpen = !this.menuOpen;
    },
    triggerWalletCacheSync() {
      if (this.walletSyncTriggered) {
        return;
      }
      this.walletSyncTriggered = true;
      this.$apiFun.post('/api/wallet/sync-cache', {}).catch(() => null);
    },
    exitPage() {
      this.menuOpen = false;
      this.triggerWalletCacheSync();
      this.$router.back();
    },
    goHome() {
      this.menuOpen = false;
      this.triggerWalletCacheSync();
      this.$router.push('/');
    },
    handleResize() {
      const next = this.clampFloatingPosition(this.floatingButton.x, this.floatingButton.y);
      this.floatingButton.x = next.x;
      this.floatingButton.y = next.y;
      this.stopDrag();
    },
    startOpeningHint() {
      this.stopOpeningHint();
      this.openingGame = true;
      this.openingGameTimer = setTimeout(() => {
        this.openingGame = false;
        this.openingGameTimer = null;
      }, 8000);
    },
    stopOpeningHint() {
      if (this.openingGameTimer) {
        clearTimeout(this.openingGameTimer);
        this.openingGameTimer = null;
      }
      this.openingGame = false;
    },
    handleIframeLoad() {
      this.stopOpeningHint();
    },
    // 打开客服
    getservicerurl() {
      let that = this;
      that.$apiFun.post('/api/getservicerurl', {}).then(res => {
        if (res.code != 200) {
          that.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.url = res.data.url;
        }
      });
    },
    // 打开代理
    getAgentLoginUrl() {
      let that = this;
      that.$apiFun.get('/api/getAgentLoginUrl', {}).then(res => {
        if (res.code != 200) {
          that.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.url = res.data.url;
        }
      });
    },
    // 打开游戏
    goGamePage(name, type, code) {
      let that = this;
      that.transferPopupOpen = false;
      that.startOpeningHint();
      that.$apiFun
        .post('/api/getGameUrl', { plat_name: name, game_type: type || 0, game_code: code, is_mobile_url: 1 })
        .then(res => {
          console.log(res);
          if (res.code != 200) {
            that.stopOpeningHint();
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.url = res.data.url;
          }
        })
        .catch(() => {
          that.stopOpeningHint();
          that.$parent.showTost(0, '进入游戏失败，请稍后重试');
        });
    },
  },
  mounted() {
    this.initFloatingButton();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    this.stopBalancePolling();
    this.stopOpeningHint();
    this.clearPressTimer();
    this.stopDrag();
    window.removeEventListener('resize', this.handleResize);
  },
  computed: {
    canRecycleBalance() {
      return Number(this.targetGameInfo.balance || 0) > 0;
    },
    recycleButtonText() {
      if (this.recycleSubmitting) {
        return '回收中...';
      }
      return this.canRecycleBalance ? '回收余额' : '暂无可回收';
    },
    displayTargetGameName() {
      return this.targetGameInfo.name || (this.preparingEntry ? '加载中...' : '-');
    },
    floatingStyle() {
      return {
        left: `${this.floatingButton.x}px`,
        top: `${this.floatingButton.y}px`,
      };
    },
  },
  watch: {
    transferPopupOpen(val) {
      if (val) {
        this.refreshTransferBalances(this.pendingGame.name, true);
        this.startBalancePolling();
        return;
      }
      this.stopBalancePolling();
    },
  },
  beforeRouteLeave(to, from, next) {
    this.triggerWalletCacheSync();
    next();
  },
};
</script>

<style lang="scss" scoped>
// @import '../../../static/css/chunk-099d4415.690b75b1.css';
.game-page {
  position: relative;
  width: 100%;
  height: 100vh;
  background: #ede9e7;
}

.game-status-hint {
  position: fixed;
  left: 50%;
  top: 50%;
  z-index: 10000;
  transform: translate(-50%, -50%);
  padding: 0.2rem 0.32rem;
  border-radius: 999px;
  background: rgba(17, 24, 39, 0.72);
  color: #fff;
  font-size: 0.28rem;
  line-height: 1;
  pointer-events: none;
}

.game-frame-wrap {
  height: 100vh;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
}

.transfer-sheet {
  padding: 0.32rem 0.32rem 0.44rem;
}

.transfer-card {
  padding: 0.28rem 0.32rem;
  border-radius: 0.24rem;
  background: #f5f7ff;
}

.transfer-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 0.28rem;
  color: #4b5563;
}

.transfer-row + .transfer-row {
  margin-top: 0.2rem;
}

.transfer-row strong {
  color: #111827;
  font-size: 0.3rem;
}

.transfer-input {
  margin-top: 0.24rem;
}

.transfer-label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.14rem;
}

.transfer-label {
  font-size: 0.28rem;
  color: #374151;
}

.transfer-recycle {
  min-width: 1.36rem;
  height: 0.52rem;
  padding: 0 0.18rem;
  border-radius: 999px;
  background: #f0ebff;
  color: #6d3df5;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.24rem;
}

.transfer-recycle.is-disabled {
  background: #eceff5;
  color: #98a2b3;
}

.transfer-input input {
  width: 100%;
  height: 0.92rem;
  border: 1px solid #d7dcf3;
  border-radius: 0.2rem;
  padding: 0 0.24rem;
  box-sizing: border-box;
  font-size: 0.3rem;
  background: #fff;
}

.transfer-actions {
  display: flex;
  gap: 0.2rem;
  margin-top: 0.3rem;
}

.transfer-action {
  flex: 1;
  height: 0.88rem;
  border-radius: 0.22rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 0.3rem;
  background: linear-gradient(135deg, #6d3df5, #8e5eff);
}

.transfer-action--ghost {
  background: #eef2ff;
  color: #4f46e5;
}

.floating-menu {
  position: fixed;
  z-index: 9999;
  transition: left 0.2s ease, top 0.2s ease, opacity 0.2s ease;
  touch-action: none;
}

.floating-menu.is-dragging {
  transition: none;
}

.floating-trigger {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: linear-gradient(135deg, #6d3df5, #8e5eff);
  box-shadow: 0 10px 24px rgba(109, 61, 245, 0.28);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  border: 2px solid rgba(255, 255, 255, 0.92);
}

.floating-trigger span {
  width: 18px;
  height: 2px;
  border-radius: 999px;
  background: #fff;
  display: block;
}

.floating-actions {
  position: absolute;
  top: 50%;
  display: flex;
  flex-direction: column;
  gap: 0.14rem;
  transform: translateY(-50%);
}

.floating-actions.actions-left {
  right: calc(100% + 0.18rem);
  align-items: flex-end;
}

.floating-actions.actions-right {
  left: calc(100% + 0.18rem);
  align-items: flex-start;
}

.floating-menu.is-edge-left .floating-actions {
  transform-origin: left center;
}

.floating-menu.is-edge-right .floating-actions {
  transform-origin: right center;
}

.floating-menu.is-edge-left .float-actions-enter,
.floating-menu.is-edge-left .float-actions-leave-to {
  opacity: 0;
  transform: translateY(-50%) translateX(-8px);
}

.floating-menu.is-edge-right .float-actions-enter,
.floating-menu.is-edge-right .float-actions-leave-to {
  opacity: 0;
  transform: translateY(-50%) translateX(8px);
}

.floating-trigger {
  position: relative;
  z-index: 2;
}

.floating-actions {
  display: flex;
  z-index: 1;
}

.action-item {
  min-width: 1.86rem;
  height: 0.84rem;
  padding: 0 0.28rem;
  border-radius: 999px;
  background: rgba(28, 28, 38, 0.86);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.32rem;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.18);
}

.float-actions-enter-active,
.float-actions-leave-active {
  transition: opacity 0.18s ease, transform 0.18s ease;
}
</style>



// WEBPACK FOOTER //
// src/components/mode/gamePage.vue